import { addYears, isAfter, isValid, parseISO } from 'date-fns';

import { formatDate } from '@boss/utils';

/**
 * The maximum number of years in the future a discount toDate is displayed to the user.
 * Beyond this window the date is intentionally hidden to avoid showing far-future or
 * effectively-perpetual end dates.
 */
const DISCOUNT_VISIBILITY_YEARS = 2;

/**
 * Returns true when toDate is a valid date that falls within the visibility window
 * (today + 2 years, inclusive).
 */
export const isWithinDiscountVisibilityWindow = (toDate?: string): boolean => {
  if (!toDate) {
    return false;
  }

  const parsed = parseISO(toDate);

  if (!isValid(parsed)) {
    return false;
  }

  const limit = addYears(new Date(), DISCOUNT_VISIBILITY_YEARS);

  return !isAfter(parsed, limit);
};

/**
 * Returns a formatted date string (dd/MM/yyyy) when the toDate falls within the
 * 2-year visibility window, otherwise returns undefined.
 */
export const getVisibleToDate = (toDate?: string): string | undefined => {
  if (!isWithinDiscountVisibilityWindow(toDate)) {
    return undefined;
  }

  return formatDate(toDate as string) || undefined;
};
